module.exports = __webpack_public_path__ + "static/img/optimiza-default.316baef2.png";